import { clientAPI } from '../configs/configs'

const urlBase = '/returns' 

export default class PublicTracking {
  static async loadPublicTrackingOrder(ped_codigo, cpf, recaptchaToken) {
    return new Promise((res, rej) => {
      try {
        clientAPI
          .post(`${urlBase}/tracking/${ped_codigo}`, {
            cpf: cpf,
            recaptchaToken: recaptchaToken
          })
          .then((response) => res(response.data))
          .catch((err) => rej(err))
      } catch (err) {
        rej(err)
      }
    })
  }
}